export default {
  SAVE_LIST_ROOM: 'SAVE_LIST_ROOM',
  SAVE_DETAIL_ROOM: 'SAVE_DETAIL_ROOM',
  SAVE_LIST_BOOKING_OF_ROOM: 'SAVE_LIST_BOOKING_OF_ROOM',
  CLEAR_ALL_DETAIL_ROOM: 'CLEAR_ALL_DETAIL_ROOM'
}
